import React, { useRef, useState } from "react";
import { ManualBox } from "../manualsBox/products-manualsBox";

export const tabList = [
    {idx: 1, title : 'Features'},
    {idx: 2, title : 'Description'},
    // {idx: 3, title : "What's In The Box"},
    {idx: 4, title : 'Specifications'},
    {idx: 5, title : 'Manuals & Firmware'},
    // {idx: 6, title : "User's Review"},
]
export const BatteryDetail = () => {
    const [state, setState] = useState<any>({first : 1, second : 1, third : 1})
    const [tabIndex, setTabIndex] = useState<number>(1)
    const scrollRef = [
        useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null)
    ];
    const handleScroll = (ref : number) => {
        if(scrollRef[ref] && scrollRef[ref].current){
            scrollRef[ref].current.scrollIntoView({
                behavior : 'smooth'
            })
        }
    }
    return(
        <>
        <div className="product_view gx7000">
            <div className="bgBox bgBoxBattery" style={{backgroundImage: "url('/assets/images/accessories/Finepower250_15.jpg')"}}>
                <div className="centerBox">
                    <h2><span>FINEVU&nbsp;</span>BATTERY PACK</h2>
                    <p>Monitor Battery Level via Fuel Gauge Display</p>
                    <ul>
                        <li onClick={()=>handleScroll(0)}>Fuel Gauge Display</li>
                        <li onClick={()=>handleScroll(1)}>Optimized for FineVu Dashcams</li>
                        <li onClick={()=>handleScroll(2)}>Seamless Integration with FineVu Dashcams</li>
                        <li onClick={()=>handleScroll(3)}>8,000mAh Fast Charging</li>
                        <li onClick={()=>handleScroll(4)}>4-Level Protection</li>
                        <li onClick={()=>handleScroll(5)}>High Temperature Cut-Off</li>
                        <li onClick={()=>handleScroll(6)}>Globally Certified</li>
                        <li onClick={()=>handleScroll(7)}>Highly Durable Material</li>
                        <li onClick={()=>handleScroll(8)}>Slim Design</li>
                        {/* <li onClick={()=>handleScroll(9)}>ADAS</li>
                        <li onClick={()=>handleScroll(10)}>High Temperature Protection</li>
                        <li onClick={()=>handleScroll(11)}>Battery Protection</li>
                        <li onClick={()=>handleScroll(12)}>Memory Allocation</li>
                        <li onClick={()=>handleScroll(13)}>Speed Camera Alert</li>
                        <li onClick={()=>handleScroll(14)}>Secret Mode</li> */}
                    </ul>
                </div>

                <div className="scrollDownBox">
                    <div>
                        <span></span>
                    </div>
                    <span>SCROLL</span>
                </div>
            </div>
            {/* <!-- bgBox Fin --> */}

            <div className="tabWrap tabBtnWrapBattery">
                <div className="tabBtnWrap">
                    <div className="tabBtnBox">
                        {tabList.map((list:{idx:number,title:string})=>(
                            <button className={tabIndex===list?.idx?'active':''} onClick={()=>setTabIndex(list?.idx)}>
                                {list?.title}
                            </button>
                        ))}
                    </div>
                </div>

                <div className="tabContentBox">
                    <div className={`features ${tabIndex === 1? 'active' : ''}`}>
                        <div className="sliderWrapBattery">
                            <ul>
                                <li className="txtBox1">
                                    <h3>
                                    <span>8,000mAh High-Capacity Battery for Fast Charging</span>
                                    </h3>
                                    <p>
                                      FineVu Battery Pack - FinePower 250
                                    </p>

                                    <div className="imgBox11">
                                        <img src="/assets/images/accessories/Finepower250_16.jpg" alt="battery"/>
                                    </div>
                                </li>
                            </ul>

                            {/* <!-- slider fin --> */}
                            <div className="dotsBox">
                                <span></span>
                                <span className="active"></span>
                                <span></span>
                            </div>
                        </div>
                        {/* <!-- sliderArea Fin --> */}


                        <div className="iconBox1">
                            <ul>
                                <li>
                                    <div>
                                        <img src="/assets/images/accessories/Finepower250_17.png" alt="battery"/>
                                    </div>
                                    <span>Fuel Gauge <br/>
                                    Display
                                    </span>
                                </li>
                                <li>
                                    <div>
                                        <img src="/assets/images/accessories/Finepower250_18.png" alt="battery"/>
                                    </div>
                                    <span>
                                        Optimized for <br/>
                                        FineVu <br/>
                                        Dashcams
                                    </span>
                                </li>
                                <li>
                                    <div>
                                        <img src="/assets/images/accessories/Finepower250_19.png" alt="battery"/>
                                    </div>
                                    <span>
                                        Seamless <br/>
                                        Integration with<br/>
                                        FineVu Dashcams
                                    </span>
                                </li>
                                <li>
                                    <div>
                                        <img src="/assets/images/accessories/Finepower250_20.png" alt="battery"/>
                                    </div>
                                    <span>
                                        8,000mAh<br/>
                                        Fast Charging
                                    </span>
                                </li>
                                <li>
                                    <div>
                                        <img src="/assets/images/accessories/Finepower250_21.png" alt="battery"/>
                                    </div>
                                    <span>
                                        4-Level<br/>
                                        Protection
                                    </span>
                                </li>
                                <li>
                                    <div>
                                        <img src="/assets/images/accessories/Finepower250_22.png" alt="battery"/>
                                    </div>
                                    <span>
                                        High Temperature<br/>
                                        Cut-Off
                                    </span>
                                </li>
                                <li>
                                    <div>
                                        <img src="/assets/images/accessories/Finepower250_23.png" alt="battery"/>
                                    </div>
                                    <span>
                                        Globally<br/>
                                        Certified
                                    </span>
                                </li>
                                <li>
                                    <div>
                                        <img src="/assets/images/accessories/Finepower250_24.png" alt="battery"/>
                                    </div>
                                    <span>
                                        Highlyl Durable<br/>
                                        Materials
                                    </span>
                                </li>
                                <li>
                                    <div>
                                        <img src="/assets/images/accessories/Finepower250_25.png" alt="battery"/>
                                    </div>
                                    <span>
                                        Slim Design
                                    </span>
                                </li>
                            </ul>
                        </div>
                        {/* <!-- iconBox Fin --> */}


                        <div className="sliderWrapBattery">
                            <ul>
                                <li className="txtBox2">
                                    <h3>
                                        <span>Monitor Battery Level<br/>via Fuel Gauge Display</span>
                                    </h3>
                                    <p>
                                        Smart Battery Pack Optimized for FineVu Dashcams
                                    </p>

                                    <div className="imgBox2">
                                        <img src="/assets/images/accessories/Finepower250_26.png" alt="battery"/>
                                    </div>
                                </li>
                            </ul>
                        </div>


                        <div className="sliderWrapBattery">
                            <ul>
                                <li className="txtBox3">
                                    <p className="txt01">
                                        Fuel Gauge Display
                                    </p>
                                    <h3>
                                    <span>With LED Indicators, Monitor Your<br/>Lithium Iron Phosphate Battery Level</span>
                                    </h3>
                                    <p className="txt02">
                                      LEDs show battery level at 0% / 25% / 50% / 75% / 100%
                                    </p>

                                    <div className="imgBox3">
                                        <img src="/assets/images/accessories/Finepower250_27.png" alt="battery"/>
                                    </div>
                                </li>
                            </ul>
                        </div>


                         <div className="sliderWrapBattery">
                            <ul>
                                <li className="txtBox3">
                                    <h3>
                                    <span>Auto Power Saving Parking Mode Activation</span>
                                    </h3>
                                    <p className="txt03"> {/* 세줄 line highe 30px */}
                                      When the battery level drops below 20%<br/>
                                      the dashcam automatically switches to Power Saving Parking Mode,<br/>
                                      allowing efficient recording even under limited power conditions.
                                    </p>

                                    <div className="imgBox4">
                                        <img src="/assets/images/accessories/Finepower250_28.png" alt="battery"/>
                                    </div>
                                     <p className="txt04">
                                     This feature is only available on FineVu dashcams that support “Power Saving Parking Mode”.
                                    </p>
                                </li>
                            </ul>
                        </div>



                         <div className="sliderWrapBattery">
                            <ul>
                                <li className="txtBox3">
                                    <p className="txt01">
                                      Optimized for FineVu Dashcams
                                    </p>
                                    <h3>
                                    <span>Specially Designed Stop Mode for FineVu Dashcams</span>
                                    </h3>
                                    <p className="txt02">
                                      The built-in Stop Mode in the battery pack works in tandem with FineVu dashcams to significantly extend usage time.
                                    </p>

                                    <div className="imgBox5">
                                        <img src="/assets/images/accessories/Finepower250_29.png" alt="battery"/>
                                    </div>
                                </li>
                                <li className="txtBox4">
                                    <p className="txt02">
                                      Detects dashcam power consumption
                                    </p>
                                    <img src="/assets/images/accessories/24_Icon.svg" alt="arrowdown"/>
                                    <p className="txt02">
                                      When dashcam enters Power Saving Parking Mode,<br/>
                                      <span>battery pack automatically enters Stop Mode</span>
                                    </p>
                                    <img src="/assets/images/accessories/24_Icon.svg" alt="arrowdown"/>
                                    <p className="txt02">
                                      Eliminates unnecessary circuits and operations
                                    </p>
                                    <img src="/assets/images/accessories/24_Icon.svg" alt="arrowdown"/>
                                    <p className="txt03">
                                      Maximizes Power Efficiency <img src="/assets/images/accessories/25_Icon.svg" alt="graph"/>
                                    </p>
                                    <p className="txt04">
                                      *Stop Mode is only supported on FineVu dashcams.
                                    </p>
                                </li>
                            </ul>
                        </div>


                        <div className="sliderWrapBattery">
                            <ul>
                                <li className="txtBox3">
                                    <p className="txt01">
                                     Seamless Intergration with FineVu Dashcams
                                    </p>
                                    <h3>
                                    <span>Battery Status Displayed on Dashcam & App</span>
                                    </h3>
                                    <p className="txt02">
                                      CABLE-FREE CONNECTION Simply connect your phone and dash cam, the battery level will be displayed in the app
                                    </p>

                                    <div className="imgBox6">
                                        <img src="/assets/images/accessories/Finepower250_30.png" alt="battery"/>
                                    </div>
                                     <p className="txt04">
                                        * When connecting to a non-FineVu dashcam, please turn the corresponding switch to OFF. <br/>
                                        (If connected to a third-party product with the switch ON, some functions may not operate properly.) <br/>
                                        * If additional accessories are connected to the ACC line of the output cable, please turn off this function before use. <br/>
                                        (Some functions may not operate correctly when accessories are connected and the switch is ON.) <br/>
                                        * When linked with a FineVu dashcam, the battery status display function becomes available <br/>
                                        approximately 5 minutes after booting. <br/>
                                        (Updates are pushed periodically.)
                                    </p>
                                </li>
                            </ul>
                        </div>


                        <div className="sliderWrapBattery">
                            <ul>
                                <li className="txtBox3">
                                    <p className="txt01">
                                     8,000mAh Fast Charging
                                    </p>
                                    <h3>
                                    <span>1,129 Hours (47 Days) Parking Surveillance <br/>Only with 70 Minutes of Charging</span>
                                    </h3>
                                    <p className="txt03"> {/* 두줄 line highe 30px */}
                                      35 minutes of driving can provide up to 23 days (564 hours) of parking surveillance. <br/>Full charge allows up to 47 days (1,129 hours) of uninterrupted monitoring
                                    </p>

                                    <div className="imgBox7">
                                        <img src="/assets/images/accessories/Finepower250_31.png" alt="battery"/>
                                    </div>

                                    <table className="battery-table">
                                    <thead>
                                        <tr>
                                        <th rowSpan={2}>Mode</th>
                                        <th colSpan={2}>Charging Time</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                        <td></td>
                                        <td>35 min</td>
                                        <td>1 hr 10 min</td>
                                        </tr>
                                        <tr>
                                        <td>Parking Mode (Motion)</td>
                                        <td>8.5 hr</td>
                                        <td>17 hr</td>
                                        </tr>
                                        <tr>
                                        <td>Power Saving Parking Mode</td>
                                        <td>23 days (564 hr)</td>
                                        <td>47 days (1,129 hr)</td>
                                        </tr>
                                    </tbody>
                                    </table>


                                     <p className="txt04">
                                        * Power consumption and usage time may vary depending on the dashcam model and operating environment.
                                        * It takes approximately 1 hour and 10 minutes to fully charge the battery.
                                    </p>
                                </li>
                            </ul>
                        </div>

                         <div className="sliderWrapBattery">
                            <ul>
                                <li className="txtBox3">
                                    <p className="txt01">
                                      4-Level Protection
                                    </p>
                                    <h3>
                                    <span>Reliable Battery Pack with<br/>4-Level Protection System</span>
                                    </h3>
                                    <p className="txt03"> {/* 두줄 line highe 30px */}
                                      The battery is equipped with a 4-Level Protection System,<br/>providing greater peace of mind and safe operation.
                                    </p>

                                    <div className="imgBox8">
                                        <div>
                                            <img src="/assets/images/accessories/Finepower250_32.png" alt="battery"/>
                                            <h3>
                                            Overcurrent<br/>
                                            Protection Circuit
                                            </h3>
                                            <p>
                                            Protects the product from <br/>
                                            overvoltage and short circuits.
                                            </p>
                                        </div>

                                        <div>
                                            <img src="/assets/images/accessories/Finepower250_33.png" alt="battery"/>
                                            <h3>
                                            Discharge<br/>
                                            Pretention Circuit
                                            </h3>
                                            <p>
                                            Prevents vehicle<br/>
                                            battery discharge.
                                            </p>
                                        </div>

                                        <div>
                                            <img src="/assets/images/accessories/Finepower250_34.png" alt="battery"/>
                                            <h3>
                                            Dedicated PCM<br/>
                                            for LiFePO₄
                                            </h3>
                                            <p>
                                            Ensures long-term safety<br/>
                                            through overcharge/<br/>
                                            discharge protection and<br/>
                                            optimized cell balancing.
                                            </p>
                                        </div>

                                        <div>
                                            <img src="/assets/images/accessories/Finepower250_35.png" alt="battery"/>
                                            <h3>
                                            Intergrated Micom<br/>
                                            Control System
                                            </h3>
                                            <p>
                                            Provides additional<br/>
                                            protection from overcurrent<br/>
                                            and overvoltage with<br/>
                                            microcontroller-based control.
                                            </p>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>

                        <div className="sliderWrapBattery">
                            <ul>
                                <li className="txtBox3">
                                    <p className="txt01">
                                      High Temperature  Cut-Off
                                    </p>
                                    <h3>
                                    <span>Even Safe In Extrem Heat Temperature</span>
                                    </h3>
                                    <p className="txt03"> {/* 두줄 line highe 30px */}
                                      When the charging temperautre exceeds 80°C,<br/>the system automatically cuts off power to protect both the dashcam and the battery pack.
                                    </p>

                                    <div className="imgBox3">
                                        <img src="/assets/images/accessories/Finepower250_36.png" alt="battery"/>
                                    </div>
                                </li>
                            </ul>
                        </div>

                         <div className="sliderWrapBattery">
                            <ul>
                                <li className="txtBox3">
                                    <p className="txt01">
                                      Globally Certified
                                    </p>
                                    <h3>
                                    <span>High Reliability<br/>with International Safety Standards</span>
                                    </h3>
                                    <p className="txt03"> {/* 두줄 line highe 30px */}
                                      FineVu’s battery pack users eco-friendly LiFePO4 cells and complies with major international certifications<br/>
                                      IEC62133, UL, CE, and UN38.3 - ensuring peace of mind.<br/>
                                      Compared to conventional lithium-ion or nickel-based batteries, it offers over 3 times the safety and stability.
                                    </p>

                                    <div className="imgBox3">
                                        <img src="/assets/images/accessories/Finepower250_37.png" alt="battery"/>
                                    </div>
                                </li>
                            </ul>
                        </div>

                        <div className="sliderWrapBattery">
                            <ul>
                                <li className="txtBox3">
                                    <p className="txt01">
                                      Slim Design
                                    </p>
                                    <h3>
                                    <span>Cutting-Edge Smart Features<br/>With 3.2cm (1.26”) Ultra-Slim Design</span>
                                    </h3>
                                    <p className="txt03"> {/* 두줄 line highe 30px */}
                                      Despite offering a fuel gauge and FineVu dashcam integration,<br/>
                                      the ultra-slim 1.26-inch (3.2 cm) design ensures optimal installation flexibility.<br/>
                                    </p>

                                    <div className="imgBox3">
                                        <img src="/assets/images/accessories/Finepower250_38.png" alt="battery"/>
                                    </div>
                                </li>
                            </ul>
                        </div>

                         <div className="sliderWrapBattery">
                            <ul>
                                <li className="txtBox3">
                                    <p className="txt01">
                                      Broad Compatibility
                                    </p>

                                    <div className="imgBox8">
                                        <div>
                                            <img src="/assets/images/accessories/Finepower250_39.png" alt="battery"/>
                                            <h3>
                                            Multi Fuse Box Cable
                                            </h3>
                                            <p>
                                            Includes 4 types of multi fuse box <br/>
                                            cables as standard, <br/>
                                            making it compatible with a wide <br/>
                                            range of vehicle environments.
                                            </p>
                                        </div>

                                        <div>
                                            <img src="/assets/images/accessories/Finepower250_40.png" alt="battery"/>
                                            <h3>
                                            Tesla Y-Cable<br/>
                                            (Sold Separately)
                                            </h3>
                                            <p>
                                            Y-shaped cable specifically<br/>
                                            designed for Tesla vehicles.
                                            </p>
                                        </div>

                                        <div>
                                            <img src="/assets/images/accessories/Finepower250_41.png" alt="battery"/>
                                            <h3>
                                            Input Cable 5m<br/>
                                            (Sold Separately)
                                            </h3>
                                            <p>
                                            Ensures long-term safety<br/>
                                            through overcharge/<br/>
                                            discharge protection and<br/>
                                            optimized cell balancing.
                                            </p>
                                        </div>

                                        <div>
                                            <img src="/assets/images/accessories/Finepower250_42.png" alt="battery"/>
                                            <h3>
                                            Cigarette Lighter Cable 30cm<br/>
                                            (Sold Separately)
                                            </h3>
                                            <p>
                                            30cm cable for easy installation via<br/>
                                            a cigarette lighter socket.<br/>
                                            </p>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>


                    </div>


                     <div className={`description ${tabIndex === 2 ? 'active' : ''}`}>
                        <section>
                            <h3>Product Description</h3>
                            <div className="imgBox9">
                                <img src="/assets/images/accessories/Finepower250_43.png" alt="battery_product_description"/>
                            </div>

                            <div className="spec-table">
                            <table>
                                <tbody>
                                <tr>
                                    <td className="num"><img src="/assets/images/accessories/Finepower250_44.png" alt="battery"/></td>
                                    <td className="title">Output</td>
                                    <td className="titledesc">Port for connecting to the dashcam</td>
                                </tr>
                                <tr>
                                    <td className="num"><img src="/assets/images/accessories/Finepower250_45.png" alt="battery"/></td>
                                    <td className="title">On/Off</td>
                                    <td className="desc">
                                    <strong>ON/OFF button for displaying battery status and other information.</strong>
                                    <ul>
                                        <li>* When not using a FineVu dashcam, turn this switch OFF.<br />
                                        (Some functions may not operate properly if a non-FineVu dashcam is connected while the switch is ON.)</li>
                                        <li>* If an external accessory is connected to the ACC line, turn this function OFF.<br />
                                        (Some functions may not operate properly if accessories are connected and the switch is ON.)</li>
                                        <li>* Battery status will be displayed on the dashcam/app after about 5 minutes of operation.</li>
                                    </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="num"><img src="/assets/images/accessories/Finepower250_46.png" alt="battery"/></td>
                                    <td className="title">Level</td>
                                    <td className="desc">
                                    <strong>Displays the battery charge level (0/25/50/75/100%) via LEDs.</strong>
                                    <ul>
                                        <li>* When the battery drops below 20%, it automatically switches to power saving parking mode and displays "charging" status.</li>
                                        <li>* While charging, the LEDs will blink, and they remain solid once fully charged.</li>
                                    </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="num"><img src="/assets/images/accessories/Finepower250_47.png" alt="battery"/></td>
                                    <td className="title">Input</td>
                                    <td className="desc">
                                    <strong>Port for connecting to the fuse box or cigarette lighter cable.</strong>
                                    <ul>
                                        <li>* Use the multi fuse box cable to connect to the appropriate fuse in your vehicle.</li>
                                        <li>* Cigarette lighter cables and Tesla Y-cables are sold separately.</li>
                                    </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="num"><img src="/assets/images/accessories/Finepower250_48.png" alt="battery"/></td>
                                    <td className="title">Power</td>
                                    <td className="desc">
                                    <strong>ON/OFF switch for the device.</strong>
                                    <ul>
                                        <li>* Please switch OFF the power if the product will not be used for an extended period.</li>
                                        <li>* Before turning OFF the power, disconnect the power cable and output connection.<br />
                                        (If the output remains connected while turning off the power, the dashcam may not shut down properly.)</li>
                                    </ul>
                                    </td>
                                </tr>
                                </tbody>
                            </table>

                            <div className="notice-box">
                                <span className="icon">ℹ️</span>
                                <span>Forcing the cable into the port may cause damage. Please check each terminal before connecting.</span>
                            </div>
                            </div>
                        </section>

                         <section>
                            <h3>Basic Configuration</h3>
                             <p className="sectionPbox">
                            Please check that the following components are included upon opening the package.<br/>
                            Components and included items are subject to change without prior notice.<br/>
                            </p>

                            <div className="imgBox10">
                                <div>
                                    <img src="/assets/images/accessories/Finepower250_49.png" alt="battery"/>
                                    <p>
                                    Main Unit
                                    </p>
                                </div>

                                <div>
                                    <img src="/assets/images/accessories/Finepower250_50.png" alt="battery"/>
                                    <p>
                                    Input Cable<br/>
                                    (2m)
                                    </p>
                                </div>

                                <div>
                                    <img src="/assets/images/accessories/Finepower250_51.png" alt="battery"/>
                                    <p>
                                    Output Cable<br/>
                                    (2m)
                                    </p>
                                </div>
                            </div>

                            <div className="imgBox10">
                                <div>
                                    <img src="/assets/images/accessories/Finepower250_52.png" alt="battery"/>
                                    <p>
                                    Muilti Fuse Box Cable
                                    </p>
                                </div>

                                <div>
                                    <img src="/assets/images/accessories/Finepower250_53.png" alt="battery"/>
                                    <p>
                                    Mounting Tape<br/>
                                    (2 pcs)
                                    </p>
                                </div>

                                <div>
                                    <img src="/assets/images/accessories/Finepower250_54.png" alt="battery"/>
                                    <p>
                                    User Manual
                                    </p>
                                </div>
                            </div>

                            <div className="notice-box">
                                <span className="icon">ℹ️</span>
                                <span>If any items are missing, please contact the retailer where you purchased the product.<br/>Our customer service center does not handle inquiries regarding missing components.</span>
                            </div>
                        </section>


                         <section>
                            <h3>Cables</h3>
                            <div className="imgBox10">
                                <div>
                                    <img src="/assets/images/accessories/Finepower250_55.png" alt="battery"/>
                                    <p>
                                    Cigaratte Lighter Cable <br/>
                                    (30cm)
                                    </p>
                                </div>

                                <div>
                                    <img src="/assets/images/accessories/Finepower250_56.png" alt="battery"/>
                                    <p>
                                    Tesla Y-Cable
                                    </p>
                                </div>

                                <div>
                                    <img src="/assets/images/accessories/Finepower250_50.png" alt="battery"/>
                                    <p>
                                    Iutput Cable<br/>
                                    (5m)
                                    </p>
                                </div>
                            </div>

                            <p className="sectionPbox2">
                            <strong>OUTPUT Connection</strong>
                            - Connect the 2-meter output cable (comprised of ACC signal wire [red], VCC power wire [yellow], and GND ground wire [black]) to the dashcam’s power cable.<br/>
                            - For 2-wire dashcams, only connect the VCC and GND wires.<br/>
                            - Make sure to strip the cable sheath and securely insulate the connection after wiring.
                            </p>

                            <p className="sectionPbox3">
                            <strong>INPUT Connection (Vehicle Fuse Box)</strong>
                            Use the included multi fuse box cable to connect the 2-meter input cable
                            (comprised of ACC signal wire [red], VCC power wire [yellow], and GND ground wire [black]) to the corresponding ACC, VCC, and GND fuse terminals in the vehicle’s fuse box.
                            </p>
                        </section>
                    </div>

                     <div className={`description ${tabIndex === 4 ? 'active' : ''}`}>
                        <section>

                            <div className="spec-table">
                                <table>
                                    <tbody>
                                    <tr>
                                        <td className="title">Model</td>
                                        <td className="titledesc">FinePower 250</td>
                                    </tr>
                                    <tr>
                                        <td className="title">Battery Type</td>
                                        <td className="desc">
                                        <ul>
                                            <li>LiFePO₄ (Lithium Iron Phosphate) 9.6V / 8A</li>
                                        </ul>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="title">Charging Time</td>
                                        <td className="desc">
                                        <ul>
                                            <li>Approx. 70 minutes</li>
                                        </ul>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="title">Dimensions / Weight</td>
                                        <td className="desc">
                                        <ul>
                                            <li>13.5 x 17.5 x 3.2 cm (5.31 x 6.89 x 1.26 in) / 965g</li>
                                        </ul>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="title">Rated Output</td>
                                        <td className="desc">
                                        <ul>
                                            <li>8.6V ~ 12.5V / 1A (Max 1.5A)</li>
                                        </ul>
                                        </td>
                                    </tr>
                                     <tr>
                                        <td className="title">Internal Protection</td>
                                        <td className="desc">
                                        <ul>
                                            <li>Fast charging protection, overcharge, over-discharge, overvoltage, and short-circuit protection</li>
                                        </ul>
                                        </td>
                                    </tr>
                                     <tr>
                                        <td className="title">Battery Safety Certification</td>
                                        <td className="desc">
                                        <ul>
                                            <li>XU103017 - 22001A</li>
                                        </ul>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </section>

                         <section>
                            <div className="sectionPbox4">
                                <div  className="cautionBox">
                                  <span><img src="/assets/images/accessories/Group 2.svg" alt="battery_caution"/></span>
                                  <strong>Caution</strong>
                                </div>
                                <p>
                                    ※ This product is compatible with vehicles that use a 12V electrical system. <br/>
                                    It cannot be installed in large vehicles with a 24V system (e.g., dump trucks, buses, cargo trucks, etc.).
                                </p>

                                <p>
                                    * If self-installation is difficult, please seek assistance from a professional installation service.<br/>
                                    * Any issues or damage caused during self-installation are the responsibility of the user.
                                </p>

                                <p>
                                1. This product is intended for 12V vehicles and requires professional installation. <br/>
                                2. Do not install or operate the product in wet conditions to avoid electric shock or malfunction. <br/>
                                3. Install the product in a location where it will not be exposed to direct sunlight, which may cause failure or fire. <br/>
                                4. Disassembly, modification, or impact may lead to product damage or fire. <br/>
                                5. Do not use this product for any purposes other than its intended use. <br/>
                                6. Always use certified and compatible parts for installation. <br/>
                                7. Be sure to connect the fuse box wires to the correct IN/OUT terminals. <br/>
                                8. After connecting the dashcam power cable, connect it to the OUTPUT terminal of the auxiliary battery. <br/>
                                </p>

                            </div>
                        </section>
                    </div>
                    {tabIndex === 5 ? <ManualBox battery={true}/> : ''}

                </div>
            </div>
        </div>
        </>
    )
}




// 혹시 몰라서 이미지만 넣은 버전 카피한 것

// import React, { useRef, useState } from "react";
// import { ManualBox } from "../manualsBox/products-manualsBox";

// export const tabList = [
//     {idx: 1, title : 'Features'},
//     {idx: 2, title : 'Description'},
//     // {idx: 3, title : "What's In The Box"},
//     {idx: 4, title : 'Specifications'},
//     // {idx: 5, title : 'Manuals & Firmware'},
//     // {idx: 6, title : "User's Review"},
// ]
// export const BatteryDetail = () => {
//     const [state, setState] = useState<any>({first : 1, second : 1, third : 1})
//     const [tabIndex, setTabIndex] = useState<number>(1)
//     const scrollRef = [
//         useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null)
//     ];
//     const handleScroll = (ref : number) => {
//         if(scrollRef[ref] && scrollRef[ref].current){
//             scrollRef[ref].current.scrollIntoView({
//                 behavior : 'smooth'
//             })
//         }
//     }
//     return(
//         <>
//         <div className="product_view gx7000">
//             <div className="bgBox" style={{backgroundImage: "url('/assets/images/accessories/Finepower250_15.jpg')"}}>
//                 <div className="centerBox">
//                     <h2><span>FINEVU&nbsp;</span>BATTERY PACK</h2>
//                     <p>Monitor Battery Level via Fuel Gauge Display</p>
//                     <ul>
//                         <li onClick={()=>handleScroll(0)}>Fuel Gauge Display</li>
//                         <li onClick={()=>handleScroll(1)}>Optimized for FineVu Dashcams</li>
//                         <li onClick={()=>handleScroll(2)}>Seamless Integration with FineVu Dashcams</li>
//                         <li onClick={()=>handleScroll(3)}>8,000mAh Fast Charging</li>
//                         <li onClick={()=>handleScroll(4)}>4-Level Protection</li>
//                         <li onClick={()=>handleScroll(5)}>High Temperature Cut-Off</li>
//                         <li onClick={()=>handleScroll(6)}>Globally Certified</li>
//                         <li onClick={()=>handleScroll(7)}>Highly Durable Material</li>
//                         <li onClick={()=>handleScroll(8)}>Slim Design</li>
//                         {/* <li onClick={()=>handleScroll(9)}>ADAS</li>
//                         <li onClick={()=>handleScroll(10)}>High Temperature Protection</li>
//                         <li onClick={()=>handleScroll(11)}>Battery Protection</li>
//                         <li onClick={()=>handleScroll(12)}>Memory Allocation</li>
//                         <li onClick={()=>handleScroll(13)}>Speed Camera Alert</li>
//                         <li onClick={()=>handleScroll(14)}>Secret Mode</li> */}
//                     </ul>
//                 </div>

//                 <div className="scrollDownBox">
//                     <div>
//                         <span></span>
//                     </div>
//                     <span>SCROLL</span>
//                 </div>
//             </div>
//             {/* <!-- bgBox Fin --> */}

//             <div className="tabWrap">
//                 <div className="tabBtnWrapBattery">
//                     <div className="tabBtnBox">
//                         {tabList.map((list:{idx:number,title:string})=>(
//                             <button className={tabIndex===list?.idx?'active':''} onClick={()=>setTabIndex(list?.idx)}>
//                                 {list?.title}
//                             </button>
//                         ))}
//                     </div>
//                 </div>

//                 <div className="tabContentBox">
//                     <div className={`features ${tabIndex === 1? 'active' : ''}`}>
//                         <div className="sliderWrap">
//                             <ul>
//                                 <li>
//                                     <div className="imgBox">
//                                         <img src="/assets/images/accessories/Finepower250_00.jpg" alt="battery"/>
//                                     </div>
//                                 </li>
//                                 <br/><br/><br/>
//                                 <li>
//                                     <div className="imgBox">
//                                         <img src="/assets/images/accessories/Finepower250_01.jpg" alt="battery"/>
//                                     </div>
//                                 </li>
//                                 <br/><br/><br/>
//                                 <li>
//                                     <div className="imgBox">
//                                         <img src="/assets/images/accessories/Finepower250_02.jpg" alt="battery"/>
//                                     </div>
//                                 </li>
//                                 <br/><br/><br/>
//                                 <li>
//                                     <div className="imgBox">
//                                         <img src="/assets/images/accessories/Finepower250_03.jpg" alt="battery"/>
//                                     </div>
//                                 </li>
//                                 <br/><br/><br/>
//                                 <li>
//                                     <div className="imgBox">
//                                         <img src="/assets/images/accessories/Finepower250_04.jpg" alt="battery"/>
//                                     </div>
//                                 </li>
//                                 <br/><br/><br/>
//                                 <li>
//                                     <div className="imgBox">
//                                         <img src="/assets/images/accessories/Finepower250_05.jpg" alt="battery"/>
//                                     </div>
//                                 </li>
//                                 <br/><br/><br/>
//                                 <li>
//                                     <div className="imgBox">
//                                         <img src="/assets/images/accessories/Finepower250_06.jpg" alt="battery"/>
//                                     </div>
//                                 </li>
//                                 <br/><br/><br/>
//                                 <li>
//                                     <div className="imgBox">
//                                         <img src="/assets/images/accessories/Finepower250_07.jpg" alt="battery"/>
//                                     </div>
//                                 </li>
//                                 <br/><br/><br/>
//                                 <li>
//                                     <div className="imgBox">
//                                         <img src="/assets/images/accessories/Finepower250_08.jpg" alt="battery"/>
//                                     </div>
//                                 </li>
//                                 <br/><br/><br/>
//                                 <li>
//                                     <div className="imgBox">
//                                         <img src="/assets/images/accessories/Finepower250_09.jpg" alt="battery"/>
//                                     </div>
//                                 </li>
//                                 <br/><br/><br/>
//                                 <li>
//                                     <div className="imgBox">
//                                         <img src="/assets/images/accessories/Finepower250_10.jpg" alt="battery"/>
//                                     </div>
//                                 </li>
//                                 <br/><br/><br/>
//                                 <li>
//                                     <div className="imgBox">
//                                         <img src="/assets/images/accessories/Finepower250_12.jpg" alt="battery"/>
//                                     </div>
//                                 </li>
//                                 <br/><br/><br/>
//                                 <li>
//                                     <div className="imgBox">
//                                         <img src="/assets/images/accessories/Finepower250_13.jpg" alt="battery"/>
//                                     </div>
//                                 </li>
//                             </ul>
//                             {/* <!-- slider fin --> */}
//                             <div className="dotsBox">
//                                 <span></span>
//                                 <span className="active"></span>
//                                 <span></span>
//                             </div>
//                         </div>
//                         {/* <!-- sliderArea Fin --> */}


//                         {/* <div className="iconBox">
//                             <ul>
//                                 <li>
//                                     <div>
//                                         <img src="/assets/images/accessories/Finepower250_01.jpg" alt="battery"/>
//                                     </div>
//                                     <span>QHD/FHD</span>
//                                 </li>
//                                 <li>
//                                     <div>
//                                         <img src="/assets/images/accessories/Finepower250_02.jpg" alt="battery"/>
//                                     </div>
//                                     <span>
//                                         HDR
//                                     </span>
//                                 </li>
//                                 <li>
//                                     <div>
//                                         <img src="/assets/images/accessories/Finepower250_03.jpg" alt="battery"/>
//                                     </div>
//                                     <span>
//                                         IPS LCD
//                                     </span>
//                                 </li>
//                                 <li>
//                                     <div>
//                                         <img src="/assets/images/accessories/Finepower250_04.jpg" alt="battery"/>
//                                     </div>
//                                     <span>
//                                         Auto<br />
//                                         Night Vision
//                                     </span>
//                                 </li>
//                                 <li>
//                                     <div>
//                                         <img src="/assets/images/accessories/Finepower250_05.jpg" alt="battery"/>
//                                     </div>
//                                     <span>
//                                         SONY STARVIS<br />
//                                         Sensor
//                                     </span>
//                                 </li>
//                                 <li>
//                                     <div>
//                                         <img src="/assets/images/accessories/Finepower250_06.jpg" alt="battery"/>
//                                     </div>
//                                     <span>
//                                         FineVu Wi-Fi<br />
//                                         App
//                                     </span>
//                                 </li>
//                             </ul>
//                             <ul>
//                                 <li>
//                                     <div>
//                                         <img src="/assets/images/accessories/Finepower250_07.jpg" alt="battery"/>
//                                     </div>
//                                     <span>
//                                         Absolute<br />
//                                         Parking Mode
//                                     </span>
//                                 </li>
//                                 <li>
//                                     <div>
//                                         <img src="/assets/images/accessories/Finepower250_08.jpg" alt="battery"/>
//                                     </div>
//                                     <span>
//                                         Smart<br />
//                                         Time Lapse
//                                     </span>
//                                 </li>
//                                 <li>
//                                     <div>
//                                         <img src="/assets/images/accessories/Finepower250_09.jpg" alt="battery"/>
//                                     </div>
//                                     <span>
//                                         ADAS
//                                     </span>
//                                 </li>
//                                 <li>
//                                     <div>
//                                         <img src="/assets/images/accessories/Finepower250_10.jpg" alt="battery"/>
//                                     </div>
//                                     <span>
//                                         High Temperature<br />
//                                         Protection
//                                     </span>
//                                 </li>
//                                 <li>
//                                     <div>
//                                         <img src="/assets/images/accessories/Finepower250_11.jpg" alt="battery"/>
//                                     </div>
//                                     <span>
//                                         Battery<br />
//                                         Protection
//                                     </span>
//                                 </li>
//                                 <li>
//                                     <div>
//                                         <img src="/assets/images/accessories/Finepower250_12.jpg" alt="battery"/>
//                                     </div>
//                                     <span>
//                                         Memory<br />
//                                         Allocation
//                                     </span>
//                                 </li>
//                             </ul>
//                             <ul>
//                                 <li>
//                                     <div>
//                                         <img src="/assets/images/accessories/Finepower250_13.jpg" alt="battery"/>
//                                     </div>
//                                     <span>
//                                         Speed Camera<br />
//                                         Alert
//                                     </span>
//                                 </li>
//                                 <li>
//                                     <div>
//                                         <img src="/assets/images/SecretMode.png" alt="Secret Mode" />
//                                     </div>
//                                     <span>
//                                         Secret<br />
//                                         Mode
//                                     </span>
//                                 </li>
//                             </ul>
//                         </div> */}
//                         {/* <!-- iconBox Fin --> */}

//                         {/* <div className="imgBox">
//                             <img src="/assets/images/productView_qhd_2k.png" alt="product view"/>
//                         </div> */}

//                         {/* <div className="resolution_tableWrap">
//                             <ul>
//                                 <li>
//                                     <span>Definition</span>
//                                     <span>FULL HD</span>
//                                     <span><span>QUAD HD</span></span>
//                                 </li>
//                                 <li>
//                                     <span>Resolution</span>
//                                     <span>1920 × 1080</span>
//                                     <span>2560 × 1440</span>
//                                 </li>
//                                 <li>
//                                     <span>Pixels</span>
//                                     <span>2,073,600</span>
//                                     <span>3,686,400</span>
//                                 </li>
//                             </ul>
//                         </div> */}

//                         {/* <section className="section_1" ref={scrollRef[0]}>
//                             <h3>
//                                 <span>Crystal Clear QHD Resolution</span>
//                                 QHD CAPTURES EVERY MOMENT REALISTICALLY
//                             </h3>
//                             <div className="slide_tabBtnWrap">
//                                 <div className={`slide_tabBtnBox number2 active_${state.first}`}>
//                                     <button onClick={()=>setState((prev:any)=>({...prev, first : 1}))}>
//                                         <span>Front</span>
//                                     </button>
//                                     <button onClick={()=>setState((prev:any)=>({...prev, first : 2}))}>
//                                         <span>Rear</span>
//                                     </button>
//                                 </div>
//                             </div>
//                             <div className="tabContentBox">
//                                 <div className={state.first === 1 ? 'active' : ''}>
//                                     <div className="imgBox">
//                                         <img src="/assets/images/detail/gx7000_section1_front.png" alt="front"/>
//                                     </div>
//                                 </div>
//                                 <div className={state.first === 2 ? 'active' : ''}>
//                                     <div className="imgBox">
//                                         <img src="/assets/images/detail/gx7000_section1_rear.png" alt="rear"/>
//                                     </div>
//                                 </div>
//                             </div>
//                         </section> */}

//                         {/* <section className="section_2" ref={scrollRef[1]}>
//                             <h3>
//                                 <span>HDR</span>
//                                 OPTIMIZED WITH HIGH DYNAMIC RANGE(HDR)
//                             </h3>
//                             <p>Exposure is balanced for keeping all details intact.</p>
//                             <div className="imgBox">
//                                 <img src="/assets/images/detail/gx7000_section2.png" alt="HDR"/>
//                             </div>
//                         </section> */}

//                         {/* <section className="section_3" ref={scrollRef[2]}>
//                             <h3>
//                                 <span>IPS LCD</span>
//                                 HIGH RESOLUTION AND WIDE VIEWING ANGLE IPS LCD<br/>
//                                 TOUCH SCREEN
//                             </h3>
//                             <p>
//                                 High resolution (800x480) of IPS LCD screen is suitable to present clearer and sharper images of video footages. On the wide LCD touch<br/>
//                                 screen, get an instant video playback, change the settings including visual/audio warnings for ADAS.
//                             </p>

//                             <div className="imgBox">
//                                 <img src="/assets/images/gx7000_section3.png" alt="IPS LCD"/>
//                             </div>
//                         </section> */}

//                         {/* <section className="section_4" ref={scrollRef[3]}>
//                             <h3>
//                                 <span>AUTO NIGHT VISION</span>
//                                 AUTOMATED NIGHT VISION ADJUSTS<br/>
//                                 BRIGHTNESS AND CONTRAST TO SECURE CLARITY
//                             </h3>
//                             <p>
//                                 Smart AI system assesses light environment and finds the perfect time to switch it on.<br/>
//                                 Keeping you completely hand-free.
//                             </p>

//                             <div className="slide_tabBtnWrap">
//                                 <div className={`slide_tabBtnBox number2 active_${state.second}`}>
//                                     <button onClick={()=>setState((prev:any)=>({...prev, second : 1}))}>
//                                         <span>NIGHT</span>
//                                     </button>
//                                     <button onClick={()=>setState((prev:any)=>({...prev, second : 2}))}>
//                                         <span>DAY</span>
//                                     </button>
//                                 </div>
//                             </div>
//                             <div className="tabContentBox">
//                                 <div className={state.second === 1 ? 'active' : ''}>
//                                     <div className="imgBox">
//                                         <img src="/assets/images/detail/gx7000_section4_night.png" alt="night"/>
//                                     </div>
//                                 </div>
//                                 <div className={state.second === 2 ? 'active' : ''}>
//                                     <div className="imgBox">
//                                         <img src="/assets/images/detail/gx7000_section4_day.png" alt="day"/>
//                                     </div>
//                                 </div>
//                             </div>
//                         </section> */}

//                         {/* <section className="section_5" ref={scrollRef[4]}>
//                             <h3>
//                                 <span>SONY STARVIS Sensor</span>
//                                 CLEAR RECORDING EVEN AT NIGHT
//                             </h3>
//                             <p>SONY STARVIS IMX335 provides unimaginably vivid image in regardless of day or night.</p>
//                             <div className="imgBox">
//                                 <img src="/assets/images/detail/detail_SONY_STARVIS_SENSOR05.png" alt="SONY STARVIS Sensor"/>
//                             </div>
//                         </section> */}

//                         {/* <section className="section_6" ref={scrollRef[5]}>
//                             <h3>
//                                 <span>Easy Wi-Fi Pairing with FineVu App</span>
//                                 CHECK THE RECORDED VIDEOS AND UPDATE THE<br/>
//                                 FIRMWARE ON FINEVU APP
//                             </h3>
//                             <div className="imgBox">
//                                 <img src="/assets/images/detail_Easy_Wi-Fi.png" alt="Easy Wi-Fi Pairing with FineVu App"/>
//                             </div>
//                             <ul>
//                                 <li>* This product has built-in Wi-Fi and does not require a separate Wi-Fi dongle.</li>
//                                 <li>* The FineVu Wi-Fi app can be downloaded from the Google Play Store / App Store.</li>
//                                 <li>* For detailed connection method, please refer to the manual.</li>
//                             </ul>
//                         </section> */}

//                         {/* <section className="section_7">
//                             <h3>
//                                 <span>SONY STARVIS Sensor</span>
//                                 PROLONGED RECORDING TIME
//                             </h3>
//                             <p>Consuming 98% less power, GX7000 records 2,583 more hours than standard parking mode.</p>
//                             <div className="imgBox">
//                                 <img src="/assets/images/gx7000_section7.png" alt="SONY STARVIS Sensor"/>
//                             </div>
//                         </section> */}

//                         {/* <section className="section_8" ref={scrollRef[6]}>
//                             <h3>A MINUTE LONG SURVEILLANCE</h3>
//                             <p>And that is not it. Any motion caught in the next 60-seconds will be secured in a minute-long footage.</p>
//                             <div className="imgBox">
//                                 <img src="/assets/images/detail_A_MINUTE_LONG_SURVEILLANCE.png" alt="A MINUTE LONG SURVEILLANCE"/>
//                             </div>
//                             <p>
//                                 Vacation, business trip, or any other long absence it may be. FineVu will look after your car.
//                                 <mark> * Impact triggers recordings.</mark>
//                             </p>
//                         </section> */}

//                         {/* <section className="section_9" ref={scrollRef[7]}>
//                             <h3>
//                                 <span>Absolute Parking Mode</span>
//                                 20-SECONDS OF COMPLETE EVIDENCE
//                             </h3>
//                             <p>FineVu’s Absolute Parking Mode secures vital 20-seconds of the accident scene.</p>
//                             <div className="imgBox">
//                                 <img src="/assets/images/detail_AbsoluteParkingMode.png" alt="Absolute Parking Mode"/>
//                             </div>
//                             <p>
//                                 10-seconds prior to the event, and 10-seconds after the event. No detail is left out from the scene. Secure the right moment with included<br/>
//                                 hardwire cable.
//                                 <mark>* Requires hardwire cable installation</mark>
//                             </p>
//                         </section> */}

//                         {/* <section className="section_10" ref={scrollRef[8]}>
//                             <h3>
//                                 <span>SMART TIME-LAPSE</span>
//                                 RECORD YOUR DRIVE WITH SMART TIME-LAPSE
//                             </h3>
//                             <p>
//                                 SMART TIME-LAPSE feature captures up to 729 minutes with no data loss.<br/>
//                                 When an impact is detected, FineVu will automatically save the footage in 30fps.
//                             </p>
//                             <div className="imgBox">
//                                 <img src="/assets/images/gx7000_section10.png" alt="SMART TIME-LAPSE"/>
//                             </div>
//                             <ul>
//                                 <li>* SMART TIME-LAPSE Specifications were measured under 32GB and compared to the default driving mode.</li>
//                                 <li>* Factors such as collision events may affect the storage volume.</li>
//                             </ul>
//                         </section> */}

//                         {/* <section className="section_11" ref={scrollRef[9]}>
//                             <h3>
//                                 <span>ADAS</span>
//                                 ADVANCED DRIVER SAFETY WARNING SYSTEMS<br/>
//                                 KEEP YOU SAFE ON THE ROAD
//                             </h3>
//                             <p>
//                                 ADAS(Advanced Driver Assistance Systems) helps safe driving with sound alerts.<br/>
//                                 The system evaluates its surroundings with integrated sensors, and warns driver if necessary.
//                             </p>
//                             <div className="imgBox">
//                                 <img src="/assets/images/detail_ADASPLUS.png" alt="ADAS"/>
//                             </div>
//                             <div className="imgBox">
//                                 <div>
//                                     <p>
//                                         <strong>Front Vehicle Motion Alert (FVMA)</strong>
//                                         While stopped in traffic, the movement of stationary vehicle ahead triggers alert to driver.
//                                     </p>
//                                 </div>
//                                 <div>
//                                     <img src="/assets/images/detail_ADASPLUS_FVMA.png" alt="ADAS"/>
//                                     <p>* This function works only when an external GPS is connected.</p>
//                                 </div>
//                             </div>
//                         </section> */}

//                         {/* <section className="section_12" ref={scrollRef[10]}>
//                             <h3>
//                                 <span>HIGH TEMPERATURE PROTECTION</span>
//                                 PROTECTS EVERYTHING EVEN AT HIGH TEMPERATURE
//                             </h3>
//                             <p>
//                                 If FineVu GX7000 starts to overheat and exceed over certain level of temperature,<br/>
//                                 GX7000 is automatically turned off to protect video footage.
//                             </p>
//                             <div className="imgBox">
//                                 <img src="/assets/images/gx7000_section12.png" alt="HIGH TEMPERATURE PROTECTION"/>
//                             </div>
//                         </section> */}

//                         {/* <section className="section_13" ref={scrollRef[11]}>
//                             <h3>
//                                 <span>Battery Protection</span>
//                                 BATTERY PROTECTION INTEGRATED
//                             </h3>
//                             <p>
//                                 FineVu is equipped with Battery Protection System. Dashcam powers down when battery voltage falls below preset value. Select your car’s
//                                 specific power setting on FineVu Wi-Fi app to maximize both dashcam and car battery with a single tap.
//                             </p>
//                             <div className="imgBox">
//                                 <img src="/assets/images/gx7000_section13.png" alt="Battery Protection"/>
//                             </div>
//                             <p>* FineVu recommends changing the low voltage settings to ‘hybrid’ when using the ISG system.</p>
//                         </section> */}

//                         {/* <section className="section_14" ref={scrollRef[12]}>
//                             <h3>
//                                 <span>MEMORY ALLOCATION</span>
//                                 EFFICIENT MEMORY MANAGEMENT
//                             </h3>
//                             <p>The memory allocation function enables efficient memory management according to the driving pattern.</p>

//                             <div className="slide_tabBtnWrap">
//                                 <div className={`slide_tabBtnBox number4 active_${state.third}`}>
//                                     <button onClick={()=>setState((prev:any)=>({...prev, third : 1}))}>
//                                         <span>Driving Priority</span>
//                                     </button>
//                                     <button onClick={()=>setState((prev:any)=>({...prev, third : 2}))}>
//                                         <span>Event Priority</span>
//                                     </button>
//                                     <button onClick={()=>setState((prev:any)=>({...prev, third : 3}))}>
//                                         <span>Parking Priority</span>
//                                     </button>
//                                     <button onClick={()=>setState((prev:any)=>({...prev, third : 4}))}>
//                                         <span>Driving Only</span>
//                                     </button>
//                                 </div>
//                             </div>
//                             <div className="tabContentBox">


//                                 <div className={state.third === 1 ? 'active' : ''}>
//                                     <div className="imgBox">
//                                         <img src="/assets/images/gx35_section14_1.png" alt="MEMORY STORAGE ALLOCATION" />
//                                     </div>
//                                 </div>
//                                 <div className={state.third === 2 ? 'active' : ''}>
//                                     <div className="imgBox">
//                                         <img src="/assets/images/gx35_section14_2.png" alt="MEMORY STORAGE ALLOCATION" />
//                                     </div>
//                                 </div>
//                                 <div className={state.third === 3 ? 'active' : ''}>
//                                     <div className="imgBox">
//                                         <img src="/assets/images/gx35_section14_3.png" alt="MEMORY STORAGE ALLOCATION" />
//                                     </div>
//                                 </div>
//                                 <div className={state.third === 4 ? 'active' : ''}>
//                                     <div className="imgBox">
//                                         <img src="/assets/images/gx35_section14_4.png" alt="MEMORY STORAGE ALLOCATION" />
//                                     </div>
//                                 </div>


//                             </div>
//                             <ul>
//                                 <li>* The MicroSD card is formatted when changing the memory allocation.</li>
//                                 <li>* The memory format type is FAT32, and if the format type is different, the dashcam proceeds with formatting automatically.</li>
//                                 <li>(After formatting, once you insert it into the device and supply it with power, the formatting will be in progress to set the memory.)</li>
//                             </ul>
//                         </section> */}

//                         {/* <section className="section_15" ref={scrollRef[13]}>
//                             <h3>
//                                 <span>Speed Camera Alert</span>
//                                 FINEVU KEEPS UP WITH THE LATEST SAFETY<br/>
//                                 CAMERA ALERT
//                             </h3>
//                             <p>
//                                 FineVu safety camera database is always up to date. Download the quarterly updates, and get informed with FineVu’s voice & visual alerts.
//                                 Worry no more about accidents and speeding tickets.
//                             </p>
//                             <div className="imgBox">
//                                 <img src="/assets/images/gx7000_section15.png" alt="Speed Camera Alert"/>
//                             </div>
//                             <ul>
//                                 <li>* This feature is not available in all areas.</li>
//                                 <li>* It operates when GPS signals are received.</li>
//                             </ul>
//                         </section> */}

//                         {/* <section className="section_16" ref={scrollRef[14]}>
//                             <h3>
//                                 <span>SECRET MODE</span>
//                                 PROTECT YOUR VIDEO FOOTAGE WITH PASSWORD
//                             </h3>
//                             <p>
//                                 The records of a dashcam can be used as a video proof for your legal protection from the arguments that you may have, as well as contains
//                                 so many private information. By setting the secret mode of FineVu GX7000,the records can be protected by password from others.
//                             </p>
//                             <div className="imgBox">
//                                 <img src="/assets/images/gx7000_section16.png" alt="SMART SD LOCK"/>
//                             </div>
//                         </section> */}

//                         {/* <section className="section_17">
//                             <h3>
//                                 <span>FORMAT FREE 2.0</span>
//                                 ADVANCED FORMAT FREE TECHNOLOGY
//                             </h3>
//                             <p>
//                                 Format Free 2.0 technology eliminates the needs of manual reformatting the micro SD memory card. Also, it helps to extend memory card<br/>
//                                 lifetime and improve reliability.
//                             </p>
//                             <div className="imgBox">
//                                 <img src="/assets/images/gx7000_section17.png" alt="FORMAT FREE 2.0"/>
//                             </div>
//                         </section> */}

//                         {/* <section className="section_18">
//                             <h3>
//                                 <span>FINEVU PC PLAYER</span>
//                                 THE OPTIMAL DASHCAM ANALYSIS PROGRAM,<br/>
//                                 FINEVU PLAYER 2.0
//                             </h3>
//                             <p>
//                                 FineVu PC player is an easy-to-use PC software of FineVu dashcam. You can playback, screenshot, enlarge the images with full resolution<br/>
//                                 and monitor the video records conveniently on your PC.
//                             </p>
//                             <div className="imgBox">
//                                 <img src="/assets/images/gx7000_section18.png" alt="FINEVU PC PLAYER"/>
//                             </div>
//                             <p>*This feature can be used after installing FineVu Player program.</p>
//                         </section> */}
//                     </div>

//                     {/* <div className={`description ${tabIndex === 2 ? 'active' : ''}`}>
//                         <section>
//                             <h3>Product Description</h3>
//                             <div className="imgBox">
//                                 <img src="/assets/images/fineVu_GX7000_spec.jpg" alt="Product Description"/>
//                             </div>
//                         </section>
//                     </div> */}

//                     {/* <div className={`whatsInTheBox ${tabIndex === 3 ? 'active' : ''}`}>
//                         <section>
//                             <div>
//                                 <h3>Basic Configuration</h3>
//                                 <div className="imgBox">
//                                     <img src="/assets/images/finevu-battery-01.png" alt="Basic Configuration"/>
//                                     <p>dfdfd</p>
//                                 </div>
//                                 <div className="imgBox">
//                                     <img src="/assets/images/finevu-battery-02.png" alt="Basic Configuration"/>
//                                     <p>dfdfd</p>
//                                 </div>
//                                 <div className="imgBox">
//                                     <img src="/assets/images/finevu-battery-03.png" alt="Basic Configuration"/>
//                                     <p>dfdfd</p>
//                                 </div>
//                                 <div className="imgBox">
//                                     <img src="/assets/images/finevu-battery-04.png" alt="Basic Configuration"/>
//                                     <p>dfdfd</p>
//                                 </div>
//                                 <ul>
//                                     <li>※ To improve the performance of the product, its components may change without prior notice.</li>
//                                     <li>※ The warranty period of the Micro SD card is 6 months.</li>
//                                 </ul>
//                             </div>
//                             <div>
//                                 <h3>Additional Options</h3>
//                                 <div className="imgBox">
//                                     <img src="/assets/images/GX7000_additional_options.png" alt="Additional Options"/>
//                                 </div>
//                             </div>
//                         </section>
//                     </div> */}

//                     {/* <div className={`specifications ${tabIndex === 4 ? 'active' : ''}`}>
//                         <div className="tableWrap">
//                             <table>
//                                 <tbody>
//                                     <tr>
//                                         <th>Model</th>
//                                         <td>
//                                             FinePower 250
//                                         </td>
//                                     </tr>
//                                     <tr>
//                                         <th>Battery Type</th>
//                                         <td>
//                                             LiFePO<sub>4</sub> (Lithium Iron Phosphate) 9.6V / 8A
//                                         </td>
//                                     </tr>
//                                     <tr>
//                                         <th>Charging Time</th>
//                                         <td>
//                                             Approx. 70 minutes
//                                         </td>
//                                     </tr>
//                                     <tr>
//                                         <th>Dimensions / Weight</th>
//                                         <td>
//                                             13.5 X 17.5 X 3.2cm (5.31 x 6.89 x 1.26 in) / 965g
//                                         </td>
//                                     </tr>
//                                     <tr>
//                                         <th>Rated Output</th>
//                                         <td>
//                                             8.6V - 12.5V / 1A (Max 1.5A)
//                                         </td>
//                                     </tr>
//                                     <tr>
//                                         <th>Internal Protection</th>
//                                         <td>Fast charging protection, overcharge, over-discharge, overvoltage, and short-circuit protection</td>
//                                     </tr>
//                                     <tr>
//                                         <th>Battery Safety Certification</th>
//                                         <td>XU103017-22001A</td>
//                                     </tr>
//                                 </tbody>
//                             </table>
//                         </div>


//                          <div className="Battery_txtBox">
//                             <span>Caution</span>
//                             <ol>
//                                 <p>
//                                 This product is compatible with vehicles that use a 12V electrical system.
//                                 It cannot be installed in large vehicles with a 24V system (e.t., dump trucks, buses, cargo trucks, etc.)
//                                 </p>
//                                 <li>
//                                     <span>1</span>
//                                     If self-installation is difficult, please seek assistance from a professional installation service.
//                                 </li>
//                                 <li>
//                                     <span>2</span>
//                                     Any issues or damage caued during self-installation are the responsibility of the use.<br/>
//                                     -This product is intended for 12V vehicles and requires professional installaion.
//                                     -Do not install or operate the product in wet conditions to avoid electric shock or malfunction.
//                                     -Install the product in a location where it will not be exposed to direct sunlight, which may cause failure or fire.'
//                                     -Disassembly, modification, or impact may lead to product damage or fire.
//                                     -Do not use this product for any purposes other than its intended use.
//                                     -Always use certified and compatible parts for installation.
//                                     -Be sure to connect the fuse box wires to the correct IN/OUT terminals.
//                                     -After connecting the dashcam power cable, connect it to the OUTPUT terminal of the auxiliary battery.
//                                 </li>
//                             </ol>
//                         </div>

//                     </div> */}

//                     {tabIndex === 5 ? <ManualBox/> : ''}

//                     <div className={`usersReview ${tabIndex === 6 ? 'active' : ''}`}>
//                         <div>
//                             <ul>
//                                 <li>
//                                     <img src="/assets/images/amazon_logo.png" alt="amazon logo"/>
//                                 </li>
//                                 <li>
//                                     <div>
//                                         <div>
//                                             <span>Saul & Vivian Batres</span>
//                                             <ul className="starBox">
//                                                 <li></li>
//                                                 <li></li>
//                                                 <li></li>
//                                                 <li></li>
//                                                 <li></li>
//                                             </ul>
//                                         </div>
//                                         <div>
//                                             <p>
//                                                 It take great high quality videos, the only thing you have to consider this is hard wire but
//                                                 you can purchase a seperate unit to connect to a DC outlet.
//                                             </p>
//                                             <p>It came with a memory card and set up was easy as well.</p>
//                                         </div>
//                                     </div>
//                                 </li>
//                                 <li>
//                                     <div>
//                                         <div>
//                                             <span>Brandon Lanham</span>
//                                             <ul className="starBox">
//                                                 <li></li>
//                                                 <li></li>
//                                                 <li></li>
//                                                 <li></li>
//                                                 <li></li>
//                                             </ul>
//                                         </div>
//                                         <div>
//                                             <p>
//                                                 Awesome dashcam. Works amazing and has high quality display and detail. Loop records
//                                                 the entire time you're driving. Highly recommend.
//                                             </p>
//                                             <p>One person found this helpful.</p>
//                                         </div>
//                                     </div>
//                                 </li>
//                             </ul>
//                             {/* <!-- amazon Fin --> */}

//                             <ul>
//                                 <li>
//                                     <img src="/assets/images/blackBoxMyCar_logo.png" alt="blackBoxMyCar logo"/>
//                                 </li>
//                                 <li>
//                                     <div>
//                                         <div>
//                                             <span>Gus</span>
//                                             <ul className="starBox">
//                                                 <li></li>
//                                                 <li></li>
//                                                 <li></li>
//                                                 <li></li>
//                                                 <li></li>
//                                             </ul>
//                                         </div>
//                                         <div>
//                                             <p>
//                                                 I’ve had a couple of dashcams in the past. Some were very difficult to navigate. With
//                                                 numerous buttons and a small unit viewing window they became complicated for this ‘ol
//                                                 man to use. This time I wanted a simple and easy dashcam to operate.
//                                             </p>
//                                             <p>
//                                                 The FineVu GX1000 meets that criteria. It’s fairly new on the market. But found a few
//                                                 YouTube videos that walked you through the set up in car, how to use and review files.
//                                                 The simplicity of setup and operation are genius. It tucks up nicely (w/o any ugly wires)
//                                                 to the windshield. Plus, with the thin cables marks hardwiring a breeze.
//                                             </p>
//                                             <p>
//                                                 The video and audio quality are fantastic. Whether you’re watching on your phone or a
//                                                 32 inch monitor! There are many different configurations you can use capture video.
//                                                 Many options for notifications and parking mods. As I said, I’m a simple man and have
//                                                 only a notice when I start my car starts up. I’ve deselected most of the dashcams
//                                                 features. Why? My new 2022 vehicle already has all the safety nannies I need.
//                                             </p>
//                                             <p>
//                                                 Lastly, I like to review the videos after taking a leisurely trip through the back country
//                                                 roads.
//                                             </p>
//                                             <p>
//                                                 I highly recommend this unit if you’re looking for a well built, easy to setup and use dash
//                                                 cam.
//                                             </p>
//                                             <p>GWB</p>
//                                         </div>
//                                     </div>
//                                 </li>
//                                 <li>
//                                     <div>
//                                         <div>
//                                             <span>Frank T.</span>
//                                             <ul className="starBox">
//                                                 <li></li>
//                                                 <li></li>
//                                                 <li></li>
//                                                 <li></li>
//                                                 <li></li>
//                                             </ul>
//                                         </div>
//                                         <div>
//                                             <p>
//                                                 So far so good. I hardwired the dashcam to my truck. I also like the feature where I can
//                                                 manually shut the camera off with a slide switch. This prevents the vehicles battery from
//                                                 being drained.
//                                             </p>
//                                             <p>
//                                                 Michael at BlackboxMyCar (Canada) has been extremely helpful with answering any
//                                                 questions. Great customer support👏
//                                             </p>
//                                             <p>I've purchased from this company in the past and will continue to do so.</p>
//                                         </div>
//                                     </div>
//                                 </li>
//                             </ul>
//                             {/* <!-- blackBoxMyCar Fin --> */}

//                             <ul>
//                                 <li>
//                                     <img src="/assets/images/unavi_logo.png" alt="unavi logo"/>
//                                 </li>
//                                 <li>
//                                     <div>
//                                         <div>
//                                             <span>Derrick Thomas</span>
//                                             <ul className="starBox">
//                                                 <li></li>
//                                                 <li></li>
//                                                 <li></li>
//                                                 <li></li>
//                                                 <li></li>
//                                             </ul>
//                                         </div>
//                                         <div>
//                                             <p>
//                                                 One of the easiest dash cameras to down load and view videos from. The videos can be
//                                                 Wi-Fi directly to the phone and sent via email or text. Crystal clear video and audio. Very
//                                                 impressed
//                                             </p>
//                                             <p>User picture</p>
//                                         </div>
//                                     </div>
//                                 </li>
//                                 <li>
//                                     <div>
//                                         <div>
//                                             <span>Ali A.</span>
//                                             <ul className="starBox">
//                                                 <li></li>
//                                                 <li></li>
//                                                 <li></li>
//                                                 <li></li>
//                                                 <li></li>
//                                             </ul>
//                                         </div>
//                                         <div>
//                                             <p>
//                                                 Most dashcams I’ve seen require it to be hooked up to the cars battery which makes
//                                                 you tuck wires everywhere. This one plugs in and uses power straight from the rear view
//                                                 mirror, not having to tuck or hide any wires.
//                                             </p>
//                                         </div>
//                                     </div>
//                                 </li>
//                             </ul>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//         </>
//     )
// }

